import './Listing';
import './Form';
import MaternityLeaveModalForm from './modals/MaternityLeaveModalForm';

Vue.component('maternity-leave-modal-form', MaternityLeaveModalForm);



// WEBPACK FOOTER //
// ./resources/assets/admin/js/maternity-leave/index.js